import StepSync from './src/steps-head';

export default StepSync;
